export enum ESortOrder {
    Asc = "asc",
    Desc = "desc",
}

export interface ICampaign {
    id: number;
    name: string;
    temp_id: number;
    temp_name: string;
    s_date: string;      
    e_date: string;        
    c_status: string;     
    c_grp: number;
    email_used: string;  
    credits_used: number;
    [k: string]: unknown;
}

export interface ICampaignListParams {
    page: number;

    active?: number | boolean;
    progress?: number | boolean;
    pc?: number | boolean;
    comp?: number | boolean;
    terminated?: number | boolean;

    sortBy?: string;
    order?: ESortOrder;
}

export interface IRawCampaignsResponse {
    camp_count: number;
    campaign_details: Record<string, ICampaign> | ICampaign[];
}

export interface ICampaignListResult<T = ICampaign> {
    items: T[];
    total: number;
    page: number;
}

/** Shape returned by GET /campaign-trash */
export interface ITrashCampaign {
    id: number | string;
    name: string;
    /** ISO datetime when the campaign was soft-deleted */
    deletedAt?: string;
    /** Original campaign status before deletion */
    c_status?: string;
    temp_name?: string;
    s_date?: string;
    e_date?: string;
    email_used?: string;
    credits_used?: number;
    c_grp?: number[];
    [k: string]: unknown;
}
